import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { CheckboxSettingUser } from '../_base/CheckboxSettingUser';
import { ENUM__settings_user_tab } from '../_base/ENUM__settings_user_tab';
import { S_TAB__user_wrapper } from '../_base/S_TAB__user_wrapper';

export const TabSettingsUserConfirmationOfActions = () => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  return (
    <S_TAB__user_wrapper type={ENUM__settings_user_tab.CONFIRMATION_OF_ACTIONS}>
      <div className="settings-general-utitle-wrapper mt-0">
        <span className="mt-1 settings-general-utitle mt-1">{t(i18n_page_settings_user.tabs.confirmation_of_actions.title)}</span>
        <CheckboxSettingUser
          settingKey="confirm_action_delete_all_tokens"
          i18nKey={i18n_page_settings_user.tabs.confirmation_of_actions.checkbox.delete_all_tokens}
        />

        <CheckboxSettingUser settingKey="confirm_action_image_to_text" i18nKey={i18n_page_settings_user.tabs.confirmation_of_actions.checkbox.image_to_text} />

        <CheckboxSettingUser
          settingKey="confirm_action_create_related_words"
          i18nKey={i18n_page_settings_user.tabs.confirmation_of_actions.checkbox.create_related_words}
        />
      </div>
    </S_TAB__user_wrapper>
  );
};
